import { useAuthSelector } from 'app/data/auth';
import callflowQueryKeys from 'app/hooks/queries/callflow/callflowQueryKeys';
import { sdk } from 'app/sdk';
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { Account } from 'types/account';
import { CallflowsPageResponse } from 'types/callflow';

interface QueryParams {
  skip?: number;
  take?: number;
  orderBy?: any;
  filters?: any;
  options?: Omit<
    UseQueryOptions<
      CallflowsPageResponse,
      Error,
      CallflowsPageResponse,
      QueryKey
    >,
    'queryKey' | 'queryFn'
  >;
}

export const useListCallflowsQuery = ({
  skip = 0,
  take = 1000,
  orderBy = [['name', 'asc']],
  filters = {},
  options = {},
}: QueryParams) => {
  // returns list of callflows
  // - just get ALL callflows+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = callflowQueryKeys.list(skip, take, orderBy, filters);

  const query = useQuery<CallflowsPageResponse, Error>(
    queryKey,
    () =>
      sdk.callflow.query.callflows(
        {
          skip,
          take,
          orderBy,
          filters,
        },
        { authToken: authState.auth_token },
      ),
    {
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,

      ...options,
      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      keepPreviousData: options?.keepPreviousData ?? true,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useListCallflowsQuery;
